import PropTypes from 'prop-types';
import React from 'react';
import { getCloudinaryImagePathById } from '../../../utilities/images';
import Rating from '../../JobV3/Elements/Rating/Rating';

import './CompanyReviewSlide.scss';

export default class CompanyReviewSlide extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        user: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
        company: PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
        }),
        quote: PropTypes.node,
        rating: PropTypes.string,
        equality: PropTypes.string,
    };

    render() {
        const injectedTransforms = {
            small: 'c_scale,r_max,f_auto,q_auto,w_60,h_60',
            xxLarge: 'c_scale,r_max,f_auto,q_auto,w_106,h_106',
        };
        return (
            <div className="component-CompanyPages-CompanyReviewSlide">
                <img
                    className="big-image"
                    src={getCloudinaryImagePathById(
                        this.props.user.src,
                        'xxLarge',
                        injectedTransforms
                    )}
                    alt={this.props.user.alt}
                />
                <div className="slide-content-container">
                    <div className="user-image-display-section">
                        <img
                            className="small-user-image"
                            src={getCloudinaryImagePathById(
                                this.props.user.src,
                                'small',
                                injectedTransforms
                            )}
                            alt={this.props.user.alt}
                        />
                        <div className="company-display-section">
                            An anonymous{' '}
                            <a href={this.props.company.url}>
                                {this.props.company.name}
                            </a>{' '}
                            review:
                        </div>
                    </div>
                    <div className="quote-text">{this.props.quote}</div>
                    <div className="answer-display">
                        <div className="wings-display-section">
                            <div className="label">
                                Overall Job Satsifaction
                            </div>
                            <div className={'wing-section'}>
                                <div className="number-display">
                                    {this.props.rating}
                                </div>
                                <Rating
                                    rating={this.props.rating}
                                    size={'medium'}
                                    showNumber={false}
                                />
                            </div>
                        </div>
                        <div className="treated-equally-section">
                            <div className="label">
                                Are women treated equally?
                            </div>
                            <div className="text">{`"${this.props.equality}"`}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
